import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  pushWorkerAssociation,
  type PushWorkerAssociationRequest,
} from 'api/admin/dayforce/pushWorkerAssociation'
import { shiftDetailKey } from 'queries/shifts/keys'
import { dayforceKeys } from './keys'

export const usePushWorkerAssociationMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (request: PushWorkerAssociationRequest) =>
      pushWorkerAssociation(request),
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: shiftDetailKey(variables.shiftId),
      })
      await queryClient.invalidateQueries({
        queryKey: dayforceKeys.all,
      })
    },
  })
}
